export const marseillePostalCode: string[] = [
  '13001',
  '13002',
  '13003',
  '13004',
  '13005',
  '13006',
  '13007',
  '13008',
  '13009',
  '13010',
  '13011',
  '13012',
  '13013',
  '13014',
  '13015',
  '13016',
  '13080',
  '13090',
  '13100',
  '13105',
  '13109',
  '13110',
  '13111',
  '13112',
  '13113',
  '13114',
  '13115',
  '13116',
  '13117',
  '13118',
  '13119',
  '13120',
  '13121',
  '13122',
  '13124',
  '13126',
  '13127',
  '13130',
  '13140',
  '13170',
  '13180',
  '13190',
  '13220',
  '13230',
  '13240',
  '13250',
  '13260',
  '13270',
  '13290',
  '13300',
  '13320',
  '13330',
  '13340',
  '13350',
  '13360',
  '13370',
  '13380',
  '13390',
  '13400',
  '13410',
  '13420',
  '13430',
  '13450',
  '13470',
  '13480',
  '13490',
  '13500',
  '13510',
  '13530',
  '13540',
  '13560',
  '13580',
  '13590',
  '13600',
  '13610',
  '13620',
  '13640',
  '13650',
  '13680',
  '13700',
  '13710',
  '13720',
  '13730',
  '13740',
  '13760',
  '13770',
  '13780',
  '13790',
  '13800',
  '13820',
  '13821',
  '13830',
  '13840',
  '13850',
  '13860',
  '13880',
  '13920',
  '13950',
  '13960',
  '13980',
  '83640',
  '84120'
];
